import { SelectionMultimediaFormat, SelectionAny } from './internal';
export class SelectionMultimediaFile extends SelectionAny {
    getFormat() {
        return this.get("FORM" /* Tag.Format */, null, SelectionMultimediaFormat);
    }
    getTitle() {
        return this.get("TITL" /* Tag.Title */);
    }
}
//# sourceMappingURL=SelectionMultimediaFile.js.map